import {FunctionComponent} from 'react';

export const LoadingSection: FunctionComponent<{
  w: `w-${string | number}`;
  h: `h-${string | number}`;
  animate?: boolean;
}> = ({w, h, animate}) => <div className={`${w} ${h} bg-gray-300 ${animate ? 'animate-pulse' : ''} rounded`} />;
